import React from 'react';
import '../styles/WaterMeter.css';
import WaterMeterDashboard from '../components/WaterMeterDashboard';

const WaterMeter = () => {
  return (
    <div className="water-meter-page">
      <WaterMeterDashboard />
    </div>
  );
};

export default WaterMeter; 